import billingPeriodCostCentrePivot from "../../../utils/services/project/accounting/billingPeriodCostCentreService";
import crudTemplate from "../../../templates/crudTemplate";

let crud = crudTemplate(billingPeriodCostCentrePivot);

function prepareItem(i) {
  return i;
}

const state = {
  ...crud.state
};

const getters = {
  ...crud.getters,
  getItem(state) {
    let item = crud.getters.getItem(state);
    return prepareItem(item);
  },
  getList(state) {
    let list = crud.getters.getList(state);
    return list.map(prepareItem);
  }
};

const actions = {
  ...crud.actions,
  batchUpdate(
    _,
    {
      params = {},
      errorHandler = () => {},
      onError = () => {},
      onSuccess = () => {},
      options = {}
    }
  ) {
    return billingPeriodCostCentrePivot.batchUpdate(
      params,
      onSuccess,
      onError,
      errorHandler,
      options
    );
  }
};

const mutations = {
  ...crud.mutations
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
